import React from "react";
import { Link } from "react-router-dom";
import Background1 from "../../assets/images/breadcum/01.jpg";
import parents from "../../assets/Upload/ParentsSpeak/10f62992-cd98-46c3-904a-c29bb033f262.png";

import { useEffect, useState } from "react";
import axios from "axios";

export default function ParentsSpeak() {
  const [dataDesc, setData] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/api/auth/get/getalltParents`
      );
      const data = res.data.filter(
        (entry) => entry.Category === "6956400c05d0d531716764b0"
      );
      console.log(res.data);
      setData(res.data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!lightboxOpen) return;
    const handleKeyPress = (e) => {
      if (e.key === "ArrowRight") nextImage();
      else if (e.key === "ArrowLeft") prevImage();
      else if (e.key === "Escape") closeLightbox();
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [lightboxOpen]);

  useEffect(() => {
    document.body.style.overflow = lightboxOpen ? "hidden" : "auto";
  }, [lightboxOpen]);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const nextImage = (e) => {
    if (e) e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % dataDesc.length);
  };

  const prevImage = (e) => {
    if (e) e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? dataDesc.length - 1 : prev - 1));
  };

  return (
    <>
      {/* <!--inner-header --> */}
      <section
        className="inner-banner bg-overlay-black-70 bg-holder"
        style={{ backgroundImage: `url(${Background1})` }}
      >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-12">
              <div className="text-center">
                <h1 className="text-white">Parent's Speak</h1>
              </div>
              <div className="d-flex justify-content-center ">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="#">Parent's Corner</a>
                  </li>
                  <li className="breadcrumb-item active">
                    <span>Parent's Speak</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-inner-header --> */}
      {/* <!--Gallery --> */}
      <section className="gallery-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="my-shuffle-container columns-2 popup-gallery full-screen">
                {dataDesc.map((data, index) => {
                  return (
                    <div className="grid-item" key={index}>
                      <div className="portfolio-item">
                        <div className="position-relative">
                          <img
                            className="img-fluid"
                            src={`${process.env.REACT_APP_BASE_API_URL}/${data.ParentsImage}`}
                            alt={data.ParentsImage}
                          />
                          <div className="portfolio-overlay">
                            <div
                              className="portfolio-img"
                              onClick={() => openLightbox(index)}
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fas fa-arrows-alt"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--Gallery --> */}

      {/* ===== LIGHTBOX ===== */}
      {lightboxOpen && (
        <div className="gallery-lightbox">
          <span className="close-btn" onClick={closeLightbox}>
            &times;
          </span>

          <span className="nav prev" onClick={prevImage}>
            &#10094;
          </span>

          <img
            src={`${process.env.REACT_APP_BASE_API_URL}/${dataDesc[currentIndex]?.ParentsImage}`}
            alt="Preview"
          />

          <span className="nav next" onClick={nextImage}>
            &#10095;
          </span>
        </div>
      )}
    </>
  );
}
